module.exports = __webpack_public_path__ + "media/images/flavours/icon-chimique_dark-4e83f610a4f699a417e68b46b1d45d0d.png";